import React from "react"
import isJWT from "validator/lib/isJWT"
import { redirect } from "react-router-dom"

import { PrivateContainer } from "containers"
import { ErrorBoundary, ProtectedRoute } from "components"

const AddProduct = React.lazy(() => import("../pages/add-product"))
const EditProduct = React.lazy(() => import("../pages/edit-product"))
const Products = React.lazy(() => import("../pages/products"))
const Users = React.lazy(() => import("../pages/users"))
const Services = React.lazy(() => import("../pages/services"))
const Service = React.lazy(() => import("../pages/service"))
const AppVersion = React.lazy(() => import("../pages/app-version"))
const Payments = React.lazy(() => import("../pages/payments"))
const SubscriptionGifts = React.lazy(() => import("../pages/subscription-gifts"))
const PremiumContract = React.lazy(() => import("../pages/add-premium-contract"))
const CustomerService = React.lazy(() => import("../pages/customer-service"))
const Sms = React.lazy(() => import("../pages/sms"))
const RoleDetails = React.lazy(() => import("../pages/role-details"))
const RoleManagement = React.lazy(() => import("../pages/role-management"))
const AccountManagement = React.lazy(() => import("../pages/account-management"))
const Jobs = React.lazy(() => import("../pages/jobs"))
const NewsEvents = React.lazy(() => import("../pages/news-events"))
const PlatformSettings = React.lazy(() => import("../pages/platform-settings"))
const MarketplaceManagement = React.lazy(() => import("../pages/marketplace-management"))
const MarketplaceDecoration = React.lazy(() => import("../pages/marketplace-decoration"))
const MarketplaceContent = React.lazy(() => import("../pages/marketplace-content"))
const MarketplaceNotifications = React.lazy(() => import("../pages/marketplace-notifications"))

const loader = () => {
  if (!isJWT(localStorage.at || "")) return redirect("/")

  return true
}

const privateRoutes = {
  loader,
  errorElement: <ErrorBoundary />,
  element: <PrivateContainer />,
  children: [
    {
      path: "/products",
      element:
        <ProtectedRoute
          allowedRoles={["viewProducts"]}

        >
          <Products />
        </ProtectedRoute>
    },
    {
      path: "/add-product",
      element:
        <ProtectedRoute
          allowedRoles={["addProduct"]}

        >
          <AddProduct />
        </ProtectedRoute>
    },
    {
      path: "/edit-product/:productId",
      element:
        <ProtectedRoute
          allowedRoles={["editProduct"]}

        >
          <EditProduct />
        </ProtectedRoute>
    },
    {
      path: "/users",
      element:
        <ProtectedRoute
          allowedRoles={["viewUsers"]}

        >
          <Users />
        </ProtectedRoute>
    },
    {
      path: "/services",
      element:
        <ProtectedRoute
          allowedRoles={["viewServices"]}

        >
          <Services />
        </ProtectedRoute>
    },
    {
      path: "/service/:contractId",
      element:
        <ProtectedRoute
          allowedRoles={["subscribeAdmin"]}

        >
          <Service />
        </ProtectedRoute>
    },
    {
      path: "/payments/:accountId/:contractId",
      element:
        <ProtectedRoute
          allowedRoles={["subscribeAdmin"]}

        >
          <Payments />
        </ProtectedRoute>
    },
    {
      path: "/app-version",
      element:
        <ProtectedRoute
          allowedRoles={["editAppVersion"]}

        >
          <AppVersion />
        </ProtectedRoute>
    },
    {
      path: "/subscription-gifts",
      element:
        <ProtectedRoute
          allowedRoles={["viewSubscriptionGifts"]}

        >
          <SubscriptionGifts />
        </ProtectedRoute>
    },
    {
      path: "/add-premium-contract",
      element:
        <ProtectedRoute
          allowedRoles={["addPremiumContract"]}

        >
          <PremiumContract />
        </ProtectedRoute>
    },
    {
      path: "/customer-service",
      element:
        <ProtectedRoute
          allowedRoles={["viewCustomerService"]}

        >
          <CustomerService />
        </ProtectedRoute>
    },
    {
      path: "/sms",
      element:
        <ProtectedRoute
          allowedRoles={["editSmsPrice"]}

        >
          <Sms />
        </ProtectedRoute>
    },
    {
      path: "/role-details/:accessId",
      element:
        <ProtectedRoute
          allowedRoles={["viewRoleManagement"]}

        >
          <RoleDetails />
        </ProtectedRoute>
    },
    {
      path: "/role-management",
      element:
        <ProtectedRoute
          allowedRoles={["viewRoleManagement"]}

        >
          <RoleManagement />
        </ProtectedRoute>
    },
    {
      path: "/account-management",
      element:
        <ProtectedRoute
          allowedRoles={["viewAccountManagement"]}

        >
          <AccountManagement />
        </ProtectedRoute>
    },
    {
      path: "/jobs",
      element:
        <ProtectedRoute
          allowedRoles={["viewJobs"]}

        >
          <Jobs />
        </ProtectedRoute>
    },
    {
      path: "/news-events",
      element:
        <ProtectedRoute
          allowedRoles={["viewNews"]}

        >
          <NewsEvents />
        </ProtectedRoute>
    },
    {
      path: "/platform-settings",
      element:
        <ProtectedRoute
          allowedRoles={["subscribeAdmin"]}
        >
          <PlatformSettings />
        </ProtectedRoute>
    },
    {
      path: "/marketplace-management/:contractId",
      element:
        <ProtectedRoute
          allowedRoles={["subscribeAdmin"]}
        >
          <MarketplaceManagement />
        </ProtectedRoute>
    },
    {
      path: "/marketplace-notifications",
      element:
        <ProtectedRoute
          allowedRoles={["subscribeAdmin"]}
        >
          <MarketplaceNotifications />
        </ProtectedRoute>
    },
    {
      path: "/marketplace-decoration",
      element:
        <ProtectedRoute
          allowedRoles={["subscribeAdmin"]}
        >
          <MarketplaceDecoration />
        </ProtectedRoute>
    },
    {
      path: "/marketplace-content",
      element:
        <ProtectedRoute
          allowedRoles={["subscribeAdmin"]}
        >
          <MarketplaceContent />
        </ProtectedRoute>
    }
  ]
}

export default privateRoutes
